
import HtmlHelper from '../utils/html-helper';
import HttpHelper from '../utils/http-helper';

export default class Workarea {

	constructor() {

		this.workareas = [];
		this.checkboxElements = [];
		this.academicWorkareaElement = document.querySelector('#academic-workarea');
		this.occupationalWorkareaElement = document.querySelector('#occupational-workarea');
	}

	getAllCheckboxes() {
		this.academicWorkareaElement.querySelectorAll('input').forEach(checkboxElement => {
			this.checkboxElements.push(checkboxElement);
		});
		this.occupationalWorkareaElement.querySelectorAll('input').forEach(checkboxElement => {
			this.checkboxElements.push(checkboxElement);
		});
	}

	async getAllData() {
		const response = await HttpHelper.fetchData(`${location.origin}/api/public/workarea?sort={"nameShort":1}`);
		this.workareas = response?.data;
	}

	loadWorkareas() {
		this.getAllData().then(() => {

			this.academicWorkareaElement.innerHTML = null;
			this.occupationalWorkareaElement.innerHTML = null;

			if (this.workareas?.length > 0) {
				this.workareas.forEach(workarea => {
					const newCheckbox = HtmlHelper.createElementFromHTML(this.renderData(workarea._id, workarea.nameShort));
					if(workarea.academic) {
						this.academicWorkareaElement.appendChild(newCheckbox);
					} else {
						this.occupationalWorkareaElement.appendChild(newCheckbox);
					}
				});
			}
			this.getAllCheckboxes();
		});
	}

	renderData(id, name) {
		return `
            <div class="input-group">
                <form class="row">
                    <label class="checkbox row" for="${id}">
                        <input type="checkbox" class="p-switch" id="${id}" name="${name}" required>
                        <span class="p-switch__slider"></span>
                        ${name ? name : ''}
                    </label>
                </form>
            </div>
        `;
	}
}
